// MODEL : FieldFilter
//
define('app/filters/controls/DateFilterControl',['require','glu/itemView','glu/datepicker/datePicker','moment','glu/$','hbs!./DateFilterControl.hbs'],function(require) {
	'use strict';

	var ItemView = require('glu/itemView'),
		DatePicker = require('glu/datepicker/datePicker'),
		moment = require('moment'),
		$ = require('glu/$');

	return ItemView.extend({

		template: require('hbs!./DateFilterControl.hbs'),

		events: {
			'change [id^="start-"]': 'updateModelValues',
			'change [id^="end-"]': 'updateModelValues'
		},

		ui: {
			$startDate: '#start-date',
			$startHour: '#start-time-hour',
			$startMinute: '#start-time-minute',
			$startAMPM: '#start-time-ampm',
			$endDate: '#end-date',
			$endHour: '#end-time-hour',
			$endMinute: '#end-time-minute',
			$endAMPM: '#end-time-ampm'
		},

		initialize: function() {
			this.initOperationMode();
			this.initVisualMode();
			this.initDatePicker();
			this.setStaticValues();

			//change operator arity, depending on 'mode'
			this.model.setArity(this.operationMode.arity);
		},

		onRender: function() {
			var startContainer = this.ui.$startDate;
			var endContainer = this.ui.$endDate;
			startContainer.html(this.datePickerStart.render().$el);
			endContainer.html(this.datePickerEnd.render().$el);

			this.datePickerStart.view.$el.find('input').prop('readonly', true);
			this.datePickerEnd.view.$el.find('input').prop('readonly', true);

			this.initTimePicker();

			this.updateModelValues();
		},

		initOperationMode: function() {
			var mode; // 'before', 'on', 'after', 'between'
			var arity;
			var dts1, dts2;
			var op = this.model.getOperator();
			if (op === 'LT') {
				mode = 'before';
				arity = 1;
				dts1 = dts2 = this.parseDateOrNull(this.model.getValue(0));
			} else if (op === 'GT') {
				mode = 'after';
				arity = 1;
				dts1 = dts2 = this.parseDateOrNull(this.model.getValue(0));
			} else if (op === 'BETWEEN_GTE_LTE') {
				mode = 'between';
				arity = 2;
				dts1 = this.parseDateOrNull(this.model.getValue(0));
				dts2 = this.parseDateOrNull(this.model.getValue(1));
			} else if (op === 'EQ') {
				mode = 'on';
				arity = 1;
				dts1 = dts2 = this.parseDateOrNull(this.model.getValue(0));
			} else {
				throw new Error('Unknown operator "' + op + '"');
			}
			this.operationMode = {
				mode: mode,
				arity: arity,
				dts1: dts1,
				dts2: dts2
			};
		},

		initVisualMode: function() {
			switch (this.operationMode.mode) {
				case 'between':
					this.operationMode.toShow = !(this.operationMode.dts1 && this.operationMode.dts2);
					break;
				case 'on':
				case 'before':
				case 'after':
					this.operationMode.toShow = !this.operationMode.dts1;
					break;
				default:
					throw new Error('Unknown mode "' + this.operationMode.mode + '"');
			}
		},

		initDatePicker: function() {
			var options = {
				tagName: 'div',
				labelText: null,
				dateFormat: 'MM/DD/YYYY',
				required: false,
				customSettings: {
					rangeSplitter: '-'
				}
			};

			options.rangePicker = false;
			options.customSettings.closeOnSelect = true;

			this.createDatepicker(options);
			this.listenTo(this.datePickerStart, 'datePicked', this.onDatepickerClose);
			this.listenTo(this.datePickerEnd, 'datePicked', this.onDatepickerClose);
		},

		initTimePicker: function() {
			if (this.model.getValues()[0]) {
				$(this.ui.$startHour).val(moment(this.model.getValues()[0]).format('h'));
				$(this.ui.$startMinute).val(moment(this.model.getValues()[0]).format('mm'));
				$(this.ui.$startAMPM).val(moment(this.model.getValues()[0]).format('a'));
			} else {
				$(this.ui.$startHour).val('12');
				$(this.ui.$startMinute).val('00');
				$(this.ui.$startAMPM).val('am');
			}

			if (this.model.getValues()[1]) {
				$(this.ui.$endHour).val(moment(this.model.getValues()[1]).format('h'));
				$(this.ui.$endMinute).val(moment(this.model.getValues()[1]).format('mm'));
				$(this.ui.$endAMPM).val(moment(this.model.getValues()[1]).format('a'));
			} else {
				$(this.ui.$endHour).val('12');
				$(this.ui.$endMinute).val('00');
				$(this.ui.$endAMPM).val('am');
			}
		},

		/**
		 * This function is primarily done here to allow unit-test
		 * the code without digging into jQuery datepicker implementation.
		 */
		createDatepicker: function(options) {
			var optStart = options;
			var optEnd = options;

			optStart.startDate = this.operationMode.dts1;
			this.datePickerStart = new DatePicker(optStart);

			optEnd.startDate = this.operationMode.dts2;
			this.datePickerEnd = new DatePicker(optEnd);
		},

		parseDateOrNull: function(sDate) {
			var res = null;
			if (/^[0-9]{4}(-[01]?[0-9](-[0-3]?[0-9](T[0-2]?[0-9](:[0-5]?[0-9](:[0-6]?[0-9](\.[0-9]{1,3})?)?)?)?)?)?$/.test(sDate)) {
				res = moment(sDate, 'YYYY-MM-DDTHH:mm:ss.SSS');
				if (!res.isValid()) {
					res = null;
				}
			}
			return res;
		},

		onDatepickerClose: function() {
			if (this.isDateTime()) {
				this.updateModelValues();
			} else {
				//pull picked values from date picker
				this.operationMode.dts1 = this.datePickerStart.startDate;
				this.operationMode.dts2 = this.datePickerEnd.startDate;

				var dateStartTimeString = moment(this.operationMode.dts1).format('MM/DD/YYYY');
				var dateEndTimeString = moment(this.operationMode.dts2).format('MM/DD/YYYY');

				var m1 = moment(dateStartTimeString, 'MM/DD/YYYY');
				var m2 = moment(dateEndTimeString, 'MM/DD/YYYY');

				//update model
				switch (this.operationMode.mode) {
					case 'between':
						if (m1.isValid() && m2.isValid()) {
							this.model.setValue(0, m1.format('YYYY-MM-DD'));
							this.model.setValue(1, m2.format('YYYY-MM-DD'));
						} else {
							this.model.setValue(0, null);
							this.model.setValue(1, null);
						}
						break;
					case 'on':
					case 'before':
					case 'after':
						if (m1.isValid()) {
							this.model.setValue(0, m1.format('YYYY-MM-DD'));
						} else {
							this.model.setValue(0, null);
						}
						break;
					default:
						throw new Error('Unknown mode "' + this.operationMode.mode + '"');
				}
			}
		},

		updateModelValues: function() {
			if (this.datePickerStart.startDate && $(this.ui.$startHour).val() && $(this.ui.$startMinute).val() && $(this.ui.$startAMPM).val()) {

				//pull picked values from date picker
				this.operationMode.dts1 = this.datePickerStart.startDate;
				this.operationMode.dts2 = this.datePickerEnd.startDate;

				var m1 = moment(moment(this.operationMode.dts1).format('YYYY-MM-DD ') + this.ui.$startHour.val() + ':' + this.ui.$startMinute.val() + ' ' + this.ui.$startAMPM.val(), 'YYYY-MM-DD h:mm a').format('YYYY-MM-DDTHH:mm:ss');
				var m2 = moment(moment(this.operationMode.dts2).format('YYYY-MM-DD ') + this.ui.$endHour.val() + ':' + this.ui.$endMinute.val() + ' ' + this.ui.$endAMPM.val(), 'YYYY-MM-DD h:mm a').format('YYYY-MM-DDTHH:mm:ss');

				//update model
				switch (this.operationMode.mode) {
					case 'between':
						this.model.setValue(0, m1);
						this.model.setValue(1, m2);
						break;
					case 'on':
					case 'before':
					case 'after':
						this.model.setValue(0, m1);
						break;
					default:
						throw new Error('Unknown mode "' + this.operationMode.mode + '"');
				}
			}
		},

		uiIsBetween: function() {
			return this.operationMode.mode === 'between';
		},

		uiDate1: function() {
			return this.model.getValues()[0] ? moment(this.model.getValues()[0]).format('D MMM YYYY') : 'Invalid date';
		},

		uiTime1: function() {
			return this.model.getValues()[0] ? moment(this.model.getValues()[0]).format('h:mma') : 'Invalid time';
		},

		uiDate2: function() {
			return this.model.getValues()[1] ? moment(this.model.getValues()[1]).format('D MMM YYYY') : 'Invalid date';
		},

		uiTime2: function() {
			return this.model.getValues()[1] ? moment(this.model.getValues()[1]).format('h:mma') : 'Invalid time';
		},

		isDateTime: function() {
			return this.model.get('fieldObject') && this.model.get('fieldObject').get('type') === 'DATETIME';
		},

		setStaticValues: function() {
			var hours = [];
			var minutes = [];
			var string = '';

			for (var i = 1; i < 13; i++) {
				hours.push(String(i));
			}

			for (var j = 0; j < 60; j++) {
				if (String(j).length === 1) {
					string = '0' + j;
				} else {
					string = j;
				}
				minutes.push(string);
			}

			this.hours = hours;
			this.minutes = minutes;
		},

		isBetween: function() {
			return this.operationMode.mode === 'between';
		},

		serializeData: function() {
			return this;
		}
	});

});

